<template>  
    <div class="container project">
        <b-row>
            <b-col>
                <b-card class="attributes text-center">
                    <b-row no-gutters>
                        <b-col class="attribute" md="4">
                            <div>
                                <strong>Application: </strong> {{applicationName}}
                            </div>
                        </b-col>
                        <b-col class="attribute" md="4">
                            <div :class="{'flash': validate['talent']}" class="validate-project">
                                <strong>Talent: </strong> <span class="talent-button" v-b-modal.talent-picker>{{talentName}}</span>
                            </div>
                        </b-col>
                        <b-col class="attribute" md="4">
                            <div :class="{'flash': validate['audio_format']}" class="validate-project">
                                <strong>Audio Format: </strong> <span class="talent-button" v-b-modal.audio-format-modal>{{formatName}}</span>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="9">
                <b-row v-if="ready" class="project-details mb-4">
                    <b-col sm="12" md="12">
                        <b-form-group label="Project Name">
                            <b-input type="text" ref="project-title" @blur="saveProject()" v-model="name" placeholder="Title" @focus="$event.target.select()" required />
                        </b-form-group>                   
                    </b-col>
                </b-row>

                <b-row v-if="ready">
                    <b-col md="6">
                        <h4>Prompts</h4>
                    </b-col>
                    <b-col md="6">
                        <div class="action-links float-right">
                            <span @click="toggleOpen(true)">Open All</span> / <span href="" @click="toggleOpen(false)">Close All</span>
                        </div>
                    </b-col>
                </b-row>
                
                <b-row v-if="ready" class="script-area">

                    <b-col sm="12" v-for="(item, index) in $store.getters['prompt/items']" v-bind:key="index">
                        <prompt
                            v-bind:key="index" 
                            v-bind:cut="index" 
                            v-bind:price_per_prompt="pricing.price_per_prompt"
                            v-bind:extra_words_price="pricing.extra_words_price"
                            v-bind:project_id="project_id"
                            v-bind:pricing="pricing"
                            v-bind:open="open"
                            v-bind:review="false"
                            :prompt="item"
                            :submitting="submit"
                            >
                        </prompt>

                    </b-col>

                    <b-col sm="12">
                        <b-button class="green float-right add-new" @click="addRow()"><font-awesome-icon icon="plus-circle" /> Add New Message</b-button>
                    </b-col>
                </b-row>

            </b-col>

            <b-col sm="12" md="3" class="project-sidebar">
                <b-card class="totals" v-if="application && application.id && talent && talent.id">
                    <b-row>
                        <b-col md="6" class="text-center">
                            <h5>Words</h5>
                            <h2>{{total_words}}</h2>
                        </b-col>
                        <b-col md="6" class="text-center">
                            <h5>Prompts</h5>
                            <h2>{{$store.getters['prompt/items'].length}}</h2>
                        </b-col>
                    </b-row>
                    <ul class="mb-3">
                        <li v-if="pricing.type == 'prompt'"><strong>Session Fee: </strong>{{record_fee}} <font-awesome-icon v-if="pricing.record_fee_threshold" id="recordFeeHlep" icon="question-circle" /></li>
                        <b-popover id="record-fee-help" title="Record Fee" :target="'recordFeeHlep'" placement="bottomleft" triggers="hover" :content="''">
                            <template slot="default">
                                <p>Session fee is waived with an order of {{pricing.record_fee_threshold}} or more prompts.</p>
                            </template>
                        </b-popover>
                        <li v-if="pricing.type == 'prompt'"><strong>Price: </strong>{{price}} / Prompt</li>
                        <li v-if="pricing.type == 'prompt'"><strong>Overage Fee: </strong>{{extra_words_fee}}  <font-awesome-icon  id="extraWordsHelp" icon="question-circle" /></li>
                        <b-popover id="extra-words-help" title="Overage Fee" :target="'extraWordsHelp'" placement="bottomleft" triggers="hover" :content="''">
                            <template slot="default">
                                <p>Each additional word over {{pricing.words_included}} is ${{extra_words_price}}</p>
                            </template>
                        </b-popover>
                    </ul>
                    <ul>
                        <li v-if="pricing.type == 'prompt'"><strong>Total Amount: </strong>{{total_amount}}</li>
                        <li v-if="pricing.type == 'month'"><strong>Words left this month: </strong>{{words_left}}</li>
                    </ul>
                    <transition name="fade">
                        <div class="loading-screen" v-if="$store.state.calculating">
                            <font-awesome-icon  icon="spinner" pulse size="3x" />
                        </div>
                    </transition>
                </b-card>

                <b-button block @click="submitProject" class="green checkout-button" v-if="application && application.id && talent && talent.id"><font-awesome-icon icon="file-upload" /> Submit Project</b-button>
            </b-col>

        </b-row>

        <talent-picker :applicationType="application" v-on:TalentPicked="showScript"></talent-picker>

        <new-project-modal v-on:ProjectModalClose="showTalentPicker"></new-project-modal>

        <audio-format-modal :value="audioFormat" v-on:FormatSet="setFormat"></audio-format-modal>

    </div>
</template>
<script>
    import Prompt from './Prompt'
    import TalentPicker from '../modals/TalentPicker'
    import NewProjectModal from './NewProjectModal'
    import AudioFormatModal from '../modals/AudioFormatModal'
    import { mapGetters, mapState } from 'vuex';
    export default {
        components: {Prompt, TalentPicker, NewProjectModal, AudioFormatModal},
        data() {
            return {
                show: false,
                project_id: null,
                name: '',
                prompts: [],
                showPicker: false,
                session_key: '',
                open: null,
                status: '',
                ready: false,
                
                format: {name: 'Select Format', id: null},


                submit: false
            };
        },
        methods: {
            setFormat () {
                this.saveProject()
            },
            toggleOpen (open) {
                this.open = open
            },
            //Add prompt to script
            addRow () {
                this.$store.commit('prompt/addItem', {index: null, item: null})
            },
            //Get the word count from the prompt text
            countWords (prompt) {
                var words = prompt.text.replace(/(^\s*)|(\s*$)/gi,"");
	            words = words.replace(/[ ]{2,}/gi," ");
	            words = words.replace(/\n/g," ");
                words = words.replace(/\s\s+/g, ' ');
                var word_count = (words == "") ? 0 : words.split(' ').length;
                return prompt.word_count = word_count;
            },
            //Calculate the height for the prompt text input
            textHeight (index, text) {
                var lines = text.split(/\r*\n/);
                return (24) * lines.length + 10 + 10;
            },
            showTalentPicker () {
                if (!!this.talent) {
                    return
                }

                this.$bvModal.show('talent-picker')    
            },
            showScript (application) {
                this.ready = true

                if (this.$store.getters['prompt/items'].length === 0) {
                    this.addRow()
                }

                this.saveProject()
            },
            async saveProject () {
                if (this.name === '') {
                    this.name = 'Untitled Project'
                }
                let data = {
                    name: this.name,
                    talent: this.talent,
                    prompts: this.prompts,
                    provider_id: window.Provider.id,
                    application_type_id: this.application.id,
                }

                if (this.audioFormat && this.audioFormat.id) {
                    data.deliverable_format_id = this.audioFormat.id
                }

                if(!this.project_id) {
                    this.$store.dispatch('project/create', {data})
                        .then(project => {
                            this.project_id = project.uuid
                            this.$store.commit('project/setCurrent', project.uuid)

                            this.$router.push({
                                name: 'project_id',
                                params: { id: this.project_id }   
                            })
                        })
                } else {
                    data.id = this.project_id

                    try {
                        const project = await this.$store.dispatch('project/update', {data})

                        this.populate(project)
                    } catch (ex) {
                        console.error(ex)
                    }
                }
            },
            configurePricing (pricePack) {
                this.pricing.words_included = pricePack.words_included
                this.pricing.price_per_prompt = parseFloat(pricePack.price)
                this.pricing.extra_words_price = parseFloat(pricePack.overage_price)
                this.pricing.record_fee = (pricePack.frequency == 'prompt') ? parseFloat(pricePack.record_fee) : null
                this.pricing.record_fee_threshold = parseInt(pricePack.record_fee_threshold)
                this.pricing.type = pricePack.frequency
            },
            populate (project) {
                if (project.status !== 'draft') {
                    this.$store.commit('project/removeCurrent')
                    this.$router.push({name: 'review', params: {id: this.project_id}})
                }

                this.project_id = project.uuid
                this.name = project.name

                if (this.$store.getters['prompt/items'].length === 0) {
                    this.addRow()
                }
            },
            submitProject () {
                this.submit = true

                if (this.talent && this.talent.id && this.audioFormat && this.audioFormat.id && (this.$store.getters['prompt/items'].length > 0 && this.$store.getters['prompt/items'][0].text != '')) {
                    this.$router.push({name: 'review', params: { id: this.project_id } })
                }

                setTimeout(() => {
                    this.submit = false
                }, 500)
            }
        },
        computed: {
            ...mapState({
                application: state => state.project.application,
                talent: state => state.project.talent,
                audioFormat: state => state.project.audioFormat,
                defaultPricing: state => state.pricing
            }),
            pricing () {
                if (!this.talent) {
                    return {
                        words_included: null,
                        price_per_prompt: null,
                        extra_words_fee: null,
                        record_fee: null,
                        type: 'prompt',
                        record_fee_threshold: null
                    }
                }

                if (this.talent.pricing.length === 0) {
                    return this.defaultPricing
                }

                let appPricing = this.talent.pricing.find(app => app.id = this.application.id)

                if (!appPricing) {
                    return this.defaultPricing
                }
                
                return {
                    words_included: appPricing.pivot.words_included,
                    price_per_prompt: parseFloat(appPricing.pivot.price),
                    extra_words_fee: parseFloat(appPricing.pivot.overage_price),
                    extra_words_price: parseFloat(appPricing.pivot.overage_price),
                    record_fee: parseFloat(appPricing.pivot.record_fee),
                    type: appPricing.pivot.frequency,
                    record_fee_threshold: appPricing.pivot.record_fee_threshold
                }
            },
            extra_words_price () {
                return this.pricing.extra_words_price.toFixed(2);
            },
            extra_words_fee () {
                let fee = 0;

                for(var i = 0; i < this.$store.getters['prompt/items'].length; i++) {
                    fee += parseFloat(this.$store.getters['prompt/items'][i].extra_words_fee);
                }

                return fee.toFixed(2);
            },
            applicationName () {
                return this.application && this.application.name ? this.application.name : 'Choose Application';
            },
            talentName () {
                return this.talent && this.talent.persona ? this.talent.persona : 'Choose Talent';
            },
            formatName () {
                return this.audioFormat && this.audioFormat.name ? this.audioFormat.name : 'Choose Format'
            },
            total_amount () {
                let total_amount = 0

                for(var i=0; i < this.$store.getters['prompt/items'].length; i++) {
                    if( typeof( this.$store.getters['prompt/items'][i].amount ) !== 'undefined' ) {
                        total_amount = total_amount + parseFloat(this.$store.getters['prompt/items'][i].amount)
                    }
                }

                let recordFee = this.pricing.record_fee_threshold && this.$store.getters['prompt/items'].length >= this.pricing.record_fee_threshold ? 0 : this.pricing.record_fee

                total_amount = parseFloat(total_amount) + parseFloat(recordFee);
                
                return "$" + total_amount.toFixed(2);
            },
            total_words () {
                var total_words = 0
                for(var i=0; i < this.$store.getters['prompt/items'].length; i++) {
                    if( typeof( this.$store.getters['prompt/items'][i].amount ) !== 'undefined' ) {
                        total_words = total_words + parseInt(this.$store.getters['prompt/items'][i].word_count);
                    }
                }
                
                return total_words;
            },
            checkoutReady () {
                if (typeof this.talent !== 'object') {
                    return false
                }
                if (this.$store.getters['prompt/items'].length === 0 || (this.$store.getters['prompt/items'].length !== 0 && this.$store.getters['prompt/items'][0].text == '')) {
                    return false
                }

                return true
            },
            words_left () {
                if(this.pricing.type == 'prompt' || (this.user == null || typeof this.user.account === 'undefined')) return null;
                
                return this.pricing.words_included - this.user.account.monthly_word_count;                
            },
            price () {
                if (!this.talent) {
                    return '--'
                }

                return '$' + this.pricing.price_per_prompt.toFixed(2);
            },
            record_fee () {
                if (!this.talent) {
                    return '--'
                }

                if (this.pricing.record_fee_threshold && this.$store.getters['prompt/items'].length >= this.pricing.record_fee_threshold) {
                    return parseFloat(0).toFixed(2)
                }

                return '$' + this.pricing.record_fee.toFixed(2)
            },
            validate () {
                return {
                    'audio_format': (this.submit && !this.audioFormat) ? true : false,
                    'talent': (this.submit && !this.talent) ? true : false,
                }
            }
        },
        async created() {
            if (typeof window.Provider !== 'undefined' && window.Provider.id !== 1 && !this.$provider.isAuthenticated()) {
                this.$router.push('/login');
                return;
            }

            this.project_id = (this.$route.params.id) ? this.$route.params.id : this.$store.state.project.current

            if (!this.$route.params.id && this.$store.state.project.current) {
                this.$router.push({
                    name: 'project_id',
                    params: { id: this.project_id }   
                })
            }

            this.ready = true

            if (!this.project_id) return

            try {
                const project = await this.$store.dispatch('project/read', this.project_id)

                this.populate(project)

                if (!this.application) {
                    this.$bvModal.show('start-project-modal')
                }

                if (this.application && !this.talent) {
                    this.$bvModal.show('talent-picker');
                }
            } catch (ex) {
                console.log(ex);
            }

        },
        mounted () {
            if (this.$route.name === 'new' && !this.project_id && !this.application) {
                return this.$bvModal.show('start-project-modal')
            }
        }
    };
</script>


// WEBPACK FOOTER //
// prompts/components/project/Project.vue